import styled, { css } from "styled-components";
import { lighten } from "polished";
import Spring from "../../components/Spring";
import { IVerifiedEmailStyleProps } from "./interfaces";

export const StyledAccount = styled(Spring)`
    overflow: hidden;
    background-color: ${p => p.theme.c.snow};
    min-height: calc(100vh - 50px);
`;

export const InnerSpring = styled.div`
    max-width: 480px;
    margin: auto;
    padding-bottom: 24px;
`;

export const Tick = styled.div`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    margin: -4px 0;
    background-color: ${p => lighten(0.04, p.theme.c.correct)};
    border-radius: 15px;
    margin-left: 6px;
    .i-tick {
        color: ${p => p.theme.c.white};
        font-size: 18px;
    }
`;

export const ProfilePicture = styled.div`
    width: 206px;
    height: 206px;
    margin: auto;
    overflow: hidden;
    display: block;
    border-radius: 103px;

    border: 6px solid ${p => p.theme.c.active};
    box-sizing: border-box;

    img,
    svg,
    [class^="i-"] {
        display: block;
        width: 194px;
        height: 194px;
        font-size: 194px;
    }

    svg,
    [class^="i-"] {
        transform: scale(1.5);
        fill: ${p => p.theme.c.active};
        color: ${p => p.theme.c.active};
    }
`;

export const ModifyProfilePicture = styled.div`
    text-align: center;
    font-size: 18px;
    margin: 8px 0 12px;
`;

export const ProfilePictureOptions = styled.div`
    margin: auto;
    display: block;
    width: 260px;
`;

export const SocialConnections = styled.div`
    max-width: 320px;
    margin: auto;
`;

export const Value = styled.div`
    line-height: 30px;
    .EditButton {
        position: absolute;
        display: inline-block;
        transition: 300ms;
        cursor: pointer;
        opacity: 0;

        ${p =>
            p.theme.sm.max(css`
                opacity: 1;
            `)}

        .i-edit {
            color: ${p => p.theme.c.grey9};
            font-size: 40px;
            margin-top: -5px;
            transition: 300ms;
            display: inline-block;
        }

        &:hover {
            transform: scale(1.2);
            .i-edit {
                color: ${p => p.theme.c.boost};
            }
        }
    }
    &:hover {
        .EditButton {
            opacity: 1;
        }
    }
`;

export const VerifiedEmail = styled.div<IVerifiedEmailStyleProps>`
    display: inline-block;
    background-color: ${p => p.theme.c.info};
    color: ${p => p.theme.c.snow};
    padding: 4px 6px;
    border-radius: 3px;
    margin-left: 8px;
    line-height: 23px;
    ${p =>
        p.verified
            ? css`
                  background-color: ${p => lighten(0.04, p.theme.c.correct)};
              `
            : undefined}
`;
